import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import RelatedSearchProductImages from "web/react/components/related-searches-rail/related-search-product-images";
import styles from "./related-designers-rail.css";

function RelatedDesignersRail({ title, designers, features }): JSX.Element {
    return (
        <Rail
            title={title}
            analyticsLabel={"related_designers"}
            className={styles.railWrapper}
            peekingCard={features.uj_peeking_card}
        >
            {designers.map((designer) => (
                <div key={designer.url} className={styles.cardWrapper}>
                    <div className={styles.designerCard}>
                        <a href={designer.url}>
                            <RelatedSearchProductImages feedUrl={designer.url} />
                        </a>
                        <a href={designer.url} className={styles.designerName}>
                            {designer.name}
                        </a>
                    </div>
                </div>
            ))}
        </Rail>
    );
}

RelatedDesignersRail.propTypes = {
    title: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.string),
    designers: PropTypes.array.isRequired,
};

export default RelatedDesignersRail;
